import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';

// DataHub Components
const DataHubDashboard = Loadable(lazy(() => import('views/dashboard/DataHubDashboard')));
const ProjectManagement = Loadable(lazy(() => import('views/projects/ProjectManagement')));
const StorageManagement = Loadable(lazy(() => import('views/storage/StorageManagement')));
const LakehouseDataSources = Loadable(lazy(() => import('views/lakehouse/LakehouseDataSources')));

// Admin Components
const RoleManagement = Loadable(lazy(() => import('views/admin/RoleManagement')));
const PermissionManagement = Loadable(lazy(() => import('views/admin/PermissionManagement')));
const UserManagement = Loadable(lazy(() => import('views/admin/UserManagement')));
const APITest = Loadable(lazy(() => import('views/datahub/APITest')));

// DataHub Routes
const DataHubRoutes = [
    {
        path: '/datahub/dashboard',
        element: <DataHubDashboard />
    },
    {
        path: '/datahub/projects',
        element: <ProjectManagement />
    },
    {
        path: '/datahub/storage',
        element: <StorageManagement />
    },
    {
        path: '/datahub/lakehouse',
        element: <LakehouseDataSources />
    },
    // Admin Routes
    {
        path: '/admin/roles',
        element: <RoleManagement />
    },
    {
        path: '/admin/permissions',
        element: <PermissionManagement />
    },
    {
        path: '/admin/users',
        element: <UserManagement />
    },

    {
        path: '/admin/api-test',
        element: <APITest />
    }
];

export default DataHubRoutes;
